<template>
  <button @click.prevent="closeSurvey">
    <Icon class="close-icon" name="xmark" art="light" />
  </button>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import Icon from './Icon'

const { mapActions } = createNamespacedHelpers('survey')

export default {
  name: 'CloseButton',
  components: {
    Icon,
  },
  methods: {
    ...mapActions(['closeSurvey']),
  },
}
</script>

<style lang="postcss" scoped>
button {
  position: absolute;
  z-index: 2;
  top: 20px;
  right: 15px;
  border: none;
  background: white;
  cursor: pointer;
  padding: 6px 10px;
}

.close-icon {
  font-size: 16px;
  color: #5bac26;
}

@media (min-width: 544px) {
  button {
    padding: 8px 12px;
    right: 20px;
  }

  .close-icon {
    font-size: 26px;
  }
}
</style>
